import { render, staticRenderFns } from "./ChordFingeringFull.vue?vue&type=template&id=95f939d2&scoped=true&"
import script from "./ChordFingeringFull.vue?vue&type=script&lang=js&"
export * from "./ChordFingeringFull.vue?vue&type=script&lang=js&"
import style0 from "./ChordFingeringFull.vue?vue&type=style&index=0&id=95f939d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f939d2",
  null
  
)

export default component.exports